<div class="container">
  <div class="row justify-content-end pr-5">
    <ngb-toast *ngIf="toast$ | async as toast"
               [autohide]="true"
               [class]="toast.type"
               [delay]="toast.delay || 10000"
               (hide)="hide(toast)">
      <ng-template ngbToastHeader>
        <span style="color:black" [ngClass]="{'fa fa-exclamation-triangle': true}"></span>
        <strong class="mx-1">ATS - </strong>{{toast.header}}
      </ng-template>

      {{toast.message}}
    </ngb-toast>
  </div>
</div>
